import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { refundInquiry } from 'actions/subscription'
import { RefundTransactionType } from 'typings/graphql'
import { processRecurlyRefund } from 'compositions/modals/cancelSubscription/util'

import {
  closeSkipAMonthRefundModal,
  openSkipAMonthRefundModal,
  openSkipAMonthSuccessModal,
} from 'compositions/modals/skipAMonth'

import useSkipAMonthModalBase from './useSkipAMonthModalBase'
import type { UseSkipAMonthModalProps } from './useSkipAMonthModalBase'


const durationMap = {
  1: 'MONTH_1',
  2: 'MONTH_2',
  3: 'MONTH_3',
}

const useSkipAMonthModalRecurly = (props: UseSkipAMonthModalProps) => {
  const { closeModal } = props

  const baseProps = useSkipAMonthModalBase(props)

  const { form } = baseProps

  const handleConfirm = useCallback(async () => {
    try {
      const { monthCount, remind } = await form.submit()

      actions.models.ui.showRequestLoader()

      const { status: refundStatus } = await refundInquiry({ transactionType: 'SKIP' as RefundTransactionType })

      // null if there is no refund available
      let refundDecision = null

      if (refundStatus && refundStatus !== 'NOT_REFUNDABLE') {
        actions.models.ui.hideRequestLoader()

        // close main modal to show refund modal
        closeModal()

        refundDecision = await openSkipAMonthRefundModal()

        // reopen loader
        actions.models.ui.showRequestLoader()

        processRecurlyRefund({ decision: refundDecision, transactionType: 'SKIP', status: refundStatus })
      }

      const { hold } = await actions.models.subscription.skipRecurly({
        duration: durationMap[monthCount],
        refundDecision,
        remind,
      })

      actions.models.ui.hideRequestLoader()

      // close all modals
      closeSkipAMonthRefundModal()
      closeModal()

      openSkipAMonthSuccessModal({
        skippedMonthCount: monthCount,
        holdId: hold.id,
      })
    }
    catch (error) {
      console.error(error)
      actions.models.ui.hideRequestLoader()
    }
  }, [ closeModal, form ])

  return {
    ...baseProps,
    onConfirm: handleConfirm,
  }
}


export default useSkipAMonthModalRecurly
